module.exports = __webpack_public_path__ + "img/04-public-realm.95c81ba8.jpg";